// extracted by mini-css-extract-plugin
module.exports = {"Auth":"Auth_Auth__P4kGe","AuthForm":"Auth_AuthForm__1TSJB"};